import React from "react";
import { observer } from "mobx-react-lite";
import CompetitionCompanies from "../../Games/CompetitionCompanies";

const CompetitionCompaniesManager = () => {
  return <CompetitionCompanies role="MGR" />;
};

export default observer(CompetitionCompaniesManager);